"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateTrackBitRate = exports.getPermissionsState = exports.hasCamera = exports.hasMicrophone = void 0;
const logger_1 = require("./logger");
const toolbox_1 = require("@streem/toolbox");
const hasMicrophone = () => __awaiter(void 0, void 0, void 0, function* () {
    const devices = yield (0, toolbox_1.getMediaDevices)('audioinput');
    return devices.length > 0;
});
exports.hasMicrophone = hasMicrophone;
const hasCamera = () => __awaiter(void 0, void 0, void 0, function* () {
    const devices = yield (0, toolbox_1.getMediaDevices)('videoinput');
    return devices.length > 0;
});
exports.hasCamera = hasCamera;
const getPermissionsState = () => __awaiter(void 0, void 0, void 0, function* () {
    // Note, permissions is still experimental.
    // The permissions we can query:
    // https://w3c.github.io/permissions/#enumdef-permissionname
    let camera = undefined;
    let microphone = undefined;
    // Safari lacks the experimental 'navigator.permissions' API and will spam our logs with 'undefined' errors
    if (navigator.permissions) {
        try {
            // @ts-ignore Bug in TypeScript dom-lib 4.4, this code is valid and typescript is wrong: https://githubmemory.com/repo/microsoft/TypeScript-DOM-lib-generator/issues/1029
            camera = yield navigator.permissions.query({ name: 'camera' });
        }
        catch (e) {
            if (e instanceof Error)
                logger_1.logger.warn('Unable to set context value permissions for camera: ', e.message);
        }
        try {
            microphone = yield navigator.permissions.query({
                // @ts-ignore Bug in TypeScript dom-lib 4.4, this code is valid and typescript is wrong: https://githubmemory.com/repo/microsoft/TypeScript-DOM-lib-generator/issues/1029
                name: 'microphone',
            });
        }
        catch (e) {
            if (e instanceof Error)
                logger_1.logger.warn('Unable to set context value permissions for microphone: ', e.message);
        }
    }
    // https://developer.mozilla.org/en-US/docs/Web/API/PermissionStatus
    // .status is deprecated, but it might still be valid.
    return Promise.resolve({
        // @ts-ignore .status is unknown
        camera: (camera === null || camera === void 0 ? void 0 : camera.state) || (camera === null || camera === void 0 ? void 0 : camera.status),
        // @ts-ignore .status is unknown
        microphone: (microphone === null || microphone === void 0 ? void 0 : microphone.state) || (microphone === null || microphone === void 0 ? void 0 : microphone.status),
    });
});
exports.getPermissionsState = getPermissionsState;
const round = (num) => Math.round((num + Number.EPSILON) * 10) / 10;
const calculateTrackBitRate = (previousBytesTransmited, previousTimestamp, currentBytesTransmitted, currentTimestamp) => {
    const timeDiff = currentTimestamp - previousTimestamp;
    const byteDiff = currentBytesTransmitted - previousBytesTransmited;
    const kiloBitsPerSecond = round(byteDiff / timeDiff) * 8;
    return kiloBitsPerSecond;
};
exports.calculateTrackBitRate = calculateTrackBitRate;
//# sourceMappingURL=media.js.map